exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.5.7@core-js/modules/_object-gops.js
// module id = 107
// module chunks = 0